import { combineReducers } from '@reduxjs/toolkit';

import LoginReducer from './login/LoginSlice';
import MessageReducer from './message/MessageSlice';

const RootReducer = combineReducers({
  login: LoginReducer,
  message: MessageReducer
});

export type RootState = ReturnType<typeof RootReducer>;

export default RootReducer;
